var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-x1{fill:#bcbcbc;}")),React.createElement("g",{"id":"Ebene_2","data-name":"Ebene 2","key":1},React.createElement("g",{"id":"Text"},[React.createElement("path",{"className":"cls-x1","d":"M7.7,9.75l2.39-1.24L7.7,7.26Z","key":0}),React.createElement("path",{"className":"cls-x1","d":"M8.61,0a8.61,8.61,0,1,0,8.61,8.61A8.62,8.62,0,0,0,8.61,0ZM13,9.55a4.79,4.79,0,0,1-.15,1.19,1.09,1.09,0,0,1-.86.84,2.48,2.48,0,0,1-.54.06l-2.8.09c-1,0-1.95-.05-2.9-.09a3.21,3.21,0,0,1-.61-.09,1,1,0,0,1-.76-.68A3.12,3.12,0,0,1,4.23,10a16,16,0,0,1,0-2.19,5.66,5.66,0,0,1,.14-1.23,1.29,1.29,0,0,1,.34-.64,1.12,1.12,0,0,1,.72-.31c.75,0,1.49-.08,2.24-.09,1,0,2,0,3,0a11.36,11.36,0,0,1,1.3.09,1,1,0,0,1,.85.66,2.85,2.85,0,0,1,.19.92A16.88,16.88,0,0,1,13,9.55Z","key":1})]))]);
}

Youtube.defaultProps = {"viewBox":"0 0 17.22 17.22"};

module.exports = Youtube;

Youtube.default = Youtube;
